<template>
  <div class="content">
    <el-form ref="schemeForm" :model="schemeForm" :rules="schemeRules"  label-width="100px">
      <el-card class="box-card">
        <div style="margin-left:30px">
          <div style="font-size: 14px;text-align: left;">为代理商某一批次的卡分配指定套餐，设置底价，下级代理商将按此批次卡的底价设置自己的底价和售价</div>
          <div style="font-size: 14px;text-align: left;">1、先选择代理商，再批量选择套餐；</div>
          <div style="font-size: 14px;text-align: left;"> 2、批量设置套餐的底价和售价；</div>
          <div style="font-size: 14px;text-align: left;"> 3、输入批量卡号或者号段；</div>
          <div style="font-size: 14px;text-align: left;"> 4、查询卡片按钮是用于校验输入的卡号或者号段是否正确；</div>
          <div style="font-size: 14px;text-align: left;"> 5、查询卡片查找的是当前页面选择的代理商非所有卡；</div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>方案信息</span>
        </div>
        <el-form-item label="方案名称" prop="name" style="width:60%">
            <el-input v-model="schemeForm.name" placeholder="方案名称"></el-input>
        </el-form-item>
        
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="color: #ff4949;margin-right: 4px;">*</span><span>套餐信息</span>
            <el-button style="margin-left:20px" type="primary" size="small" @click="handleAddProduct">添加</el-button>
        </div>
        <!-- <el-form-item label="" style="margin-top: 10px;"> -->
          <el-table :data="schemeForm.services" row-key="operationId"
            :default-expand-all="true" max-height="400" border
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <!-- <el-table-column type="index" align="center" width="60px"></el-table-column> -->
            <el-table-column prop="id" label="编号" align="center" width="100"></el-table-column>
            <el-table-column prop="productName" label="套餐名称" align="center" width="148" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="showProductName" label="公众号展示名称" align="center" width="200">
              <template #default={row}>
                <el-input v-if="!!row.productName" v-model="row.showProductName"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="productType" label="套餐类型" align="center" width="128" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="flowCount" label="流量" align="center" width="100" ></el-table-column>
            <el-table-column prop="operationName" label="运营商" align="center" width="100" ></el-table-column>
            <el-table-column prop="price" label="原价" align="center" ></el-table-column>
            <el-table-column prop="ledgerPrice" label="底价（元）" align="center" width="148">
              <template #default={row}>
                <el-input style="width: 80px;" v-model="row.ledgerPrice"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="salePrice" label="售价（元）" align="center" width="148">
              <template #default={row}>
                <el-input style="width: 80px;" v-model="row.salePrice"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="148">
              <template #default={row}>
                <el-button v-if="!!row.id" type="text" @click="deleteProduct(row)">移除套餐</el-button>
              </template>
            </el-table-column>
          </el-table>
        <!-- </el-form-item> -->
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>
              <el-tooltip content="此方案划拨一批卡片" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              卡片选择
            </span>
        </div>
        <el-form-item label="代理商" prop="userId" style="width:60%">
            <el-select v-model="schemeForm.userId" placeholder="请选择代理商" clearable filterable  style="width:100%">
              <el-option v-for="item in agentList" :key="item.userId" :label="'['+`${item.username}`+']' + `${item.company}`" :value="item.userId"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="ICCID列表" prop="iccids" >
          <el-input
            v-model="schemeForm.iccids"
            type="textarea"
            :placeholder="'以回车键分割ICCID\n'"
            rows="6"
            style="width:420px;font-size:14px"
          ></el-input>
      </el-form-item>
      <el-form-item label="ICCID范围" prop="startIccid" >
        <el-input
          v-model="schemeForm.startIccid"
          style="width: 200px;margin-right: 10px;"
          placeholder="包含开始值"
        ></el-input>
        <span>-</span>
        <el-input
          v-model="schemeForm.endIccid"
          style="width: 200px;margin-left: 10px;"
          placeholder="包含终止值"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" size="medium" @click="handleSeleectCard">查询卡片</el-button>
      </el-form-item>

      <el-table :data="tableData">
        <el-table-column type="index" label="编号" align="center" width="100"></el-table-column>
        <el-table-column prop="iccid" label="ICCID" align="center" width="200"></el-table-column>
        <el-table-column prop="msisdn" label="MSISDN" align="center" width="160"></el-table-column>
        <el-table-column prop="agentName" label="代理商" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="operationName" label="运营商" align="center" width="100" ></el-table-column>
      </el-table>
      <div class="block" style="margin-top: 30px;">
        <pagination v-show="tableTotal>0" :total="tableTotal" :page-sizes="[10, 20, 30, 40]" :page-size="tablePageSize" :page.sync="tablePage"
          :limit.sync="tablePageSize" @pagination="initTableData" />
      </div>
      </el-card>
    </el-form>
    <div class="foot">
			<el-button type="primary" @click="submitScheme">保存方案</el-button>
		</div>
      <!--添加套餐-->
		<el-dialog title="添加套餐" :visible.sync="addProductOpen" width="1000px" append-to-body>
			<el-form :model="productForm" ref="productForm" :inline="true">
				<el-form-item label="套餐名称">
					<el-input v-model="productForm.productName" placeholder="请输入套餐名称" clearable
						style="width: 200px;margin-right: 20px;" />
				</el-form-item>
				<el-form-item label="套餐类型">
					<el-select style="width:160px" v-model="productForm.productType" filterable clearable placeholder="请选择">
						<el-option v-for="dict in productTypes" :key="dict.key" :label="dict.value"
							:value="dict.key">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="productDataPage">搜索</el-button>
				</el-form-item>
			</el-form>
			<!-- table -->
      <el-table :data="productData" height="500"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        @selection-change="handleSelectionProductChange" row-key="operationId">
        <el-table-column type="selection" align="center" width="60px" reserve-selection></el-table-column>
        <el-table-column prop="id" label="编号" align="center" width="100"></el-table-column>
        <el-table-column prop="productName" label="套餐名称" align="center" width="148" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="productType" label="套餐类型" align="center" width="128" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="flowCount" label="流量" align="center" width="100" ></el-table-column>
        <el-table-column prop="showFlowCount" label="展示流量" align="center" width="100" ></el-table-column>
        <el-table-column prop="operationName" label="运营商" align="center" width="100" ></el-table-column>
        <el-table-column prop="price" label="运营商价格" align="center" ></el-table-column>
      </el-table>
      <div class="block" style="margin-top: 30px;display: flex;justify-content: space-between;align-items: center;">
        <div>已选套餐：{{selectionProduct.length}}个</div>
        <pagination v-show="productTotal>0" :total="productTotal" :page-sizes="[10, 20, 30, 40]" :page-size="productForm.pageSize" :page.sync="productForm.page"
          :limit.sync="productForm.pageSize" @pagination="productDataPage" />
      </div>
			<div class="dialog-footer" slot="footer">
				<el-button  type="primary" plain @click="confirmAddProduct">确定</el-button>
			</div>
		</el-dialog>
  </div>
</template>
<script>
import { agentListsData , productType , commonProductPage , cardList} from "@/api/api.js"; 
import { saveBaseScheme } from "@/api/api.js";
export default {
  name:'schemeAdd',
  data() {
    return {
      schemeForm:{
        productName:undefined,
        userId:undefined,
        iccids:undefined,
        startIccid:undefined,
        endIccid:undefined,
        services:[]
      },
      schemeRules:{
        name: [
          { required: true, message: "请输入方案名称", trigger: "blur" },
        ],
      },
      agentList:[],
      addProductOpen:false,
      productForm:{
        name:undefined,
        type:undefined,
        page:1,
        pageSize:10
      },
      productTotal:0,
      productTypes:[],
      productData:[],
      selectionProduct:[],
      tableLoading:false,
      tableData:[],
      tableTotal:0,
      tablePage:1,
      tablePageSize:10,
    };
  },
  methods: {
    initAgentList(){
      let params = {
        model: {
            commissionModel:1,
            levels:["1"]
        },
        page: 1,
        pageSize: 5000,
      };
      agentListsData(params).then(res => {
        this.agentList = res.data.data.records;
      });
    },
    //套餐类型列表
    productTypeList(){
      productType().then(res =>{
         this.productTypes = res.data.data;
      })   
    },
    productDataPage(){
      let params = {
        model:{
          ...this.productForm,
        },
        page: this.productForm.page,
        pageSize: this.productForm.pageSize,
      };
      commonProductPage(params).then(res => {
        this.productData = res.data.data.records;
        this.productTotal = res.data.data.total;
        this.productData.forEach(item => {
          item.flowCount = this.formatFlow(item.flowCount);
          item.showFlowCount = this.formatFlow(item.showFlowCount);
          item.status = this.transferIsDisable(item.status);
        })
      });
    },
    handleAddProduct(){
      this.productTypeList()
      this.productDataPage()
      this.addProductOpen = true
    },
    handleSelectionProductChange(products){
      this.selectionProduct = products
    },
    confirmAddProduct(){
      this.addProductOpen = false
      let scs = this.schemeForm.services.map(m=>m.id)
      let products = this.selectionProduct.filter(item=>scs.indexOf(item.id) == -1)
      this.schemeForm.services.push(...products)
    },
    deleteProduct(row){
      let services = this.schemeForm.services;
      for (let i = services.length - 1; i >= 0; i--) {
        if (services[i].id === row.id) {
          services.splice(i, 1);
        }
      }
    },
    handleSeleectCard(){
      if(!this.schemeForm.userId){
        this.$modal.msgError("请选择代理商");
        return 
      }
      this.initTableData()
    },
    initTableData(){
      this.tableLoading = true;
      let params = {
        model:{
					userId:this.schemeForm.userId,
          iccid: this.schemeForm.iccids && this.schemeForm.iccids.replace(/\n/g, ' '),
          startIccid:this.schemeForm.startIccid,
          endIccid:this.schemeForm.endIccid
				},
        page: this.tablePage,
        pageSize: this.tablePageSize,
      };
      cardList(params).then(res => {
          this.tableData = res.data.data.records;
          this.tableTotal = res.data.data.total;
          this.loading = false;
      });
    },
    submitScheme(){
      this.$refs.schemeForm.validate(valid=>{
        if (valid) {
          let data = this.getProdcutData()
          if(data.length == 0){
            this.$modal.msgError("请选择套餐");
            return 
          }
          let arrShow = true;
          let msg = "底价或者售价输入不正确";
          data.forEach(item=>{
            if(!item.ledgerPrice){
              arrShow = false
              msg="底价不能为空";
              return 
            }
            if(item.ledgerPrice == 0){
              arrShow = false
              msg="底价必须大于0";
              return 
            }
            if(!item.salePrice){
              arrShow = false
              msg="售价不能为空";
              return 
            }
            if(item.salePrice < item.ledgerPrice){
              arrShow = false
              msg="售价必须大于底价";
              return 
            }
          })
          if(!arrShow){
            this.$modal.msgError(msg);
            return 
          }else{
            //保存方案
            let params = {
              ...this.schemeForm,
              iccids:!!this.schemeForm.iccids ? this.schemeForm.iccids.split("\n") : []
            };
            saveBaseScheme(params).then(res=>{
              this.$message({type: 'success',message: '新建方案成功'});
              this.$router.push('/scheme/list')
            })
          }
        }
      })
    },
    getProdcutData(){
      let data = this.schemeForm.services;
      if(!!data && data.length>0){
        let prodcuts = []
        data.forEach(item=>{
          prodcuts.push(item)
          let children = item.children;
          if(children && children.length>0){
              children.forEach(ch=>{
                prodcuts.push(ch);
              })
          }
        })
        return prodcuts;
      }
      return [];  
    },
    // 状态转换
    transferIsDisable(status) {
      let obj = {
        0: "未启用",
        1: "启用中"
      };
      return obj[status];
    },
    formatFlow(flow){
      if(!flow){
        return null;
      }
      if(0 > flow){
        flow = "畅享";
      }else if(1024 > flow > 0){
        flow = flow + 'M';
      }else if(flow >= 1024){
        flow = (flow/1024).toFixed(2) + 'G';
      }
      return flow;
    },
  },
  mounted() {
  },
  created() {
    this.initAgentList()
  }
};
</script>
<style scoped lang="less">
  .box-card {
    margin-bottom: 26px;
  }
  .foot {
		width: calc(100% - 210px);
		position: fixed;
		right: 0;
		bottom: 0;
		height: 60px;
		line-height: 60px;
		background-color: white;
		text-align: center;
		padding: 0 20px;
    z-index: 99999;
	}
</style>
